import { ComponentProps } from 'react'
import { VictoryPie } from '../victory'

type PieChartProps = ComponentProps<typeof VictoryPie>

export function PieChart(props: PieChartProps) {
  return <VictoryPie {...props} />
}
